<div class="div-panel">
    <mat-horizontal-stepper
        linear
        #stepper
        (selectionChange)="onStepChange($event)"
    >
        <mat-step label [editable]="true">
            <ng-template matStepLabel>Select Correction Steps</ng-template>
            <div
                class="steps-summary"
                *ngIf="correctionSteps$ | async as steps"
            >
                <div class="correction-steps" *ngIf="steps.length > 0">
                    <app-batch-process-step-display
                        *ngFor="let step of steps"
                        [step]="step"
                        [fieldTypeValues]="fieldTypeValues$ | async"
                        (removeStepEvent)="onRemoveStep($event)"
                    >
                    </app-batch-process-step-display>
                </div>
                <p *ngIf="steps.length === 0" class="no-steps-message">
                    No correction steps defined yet. Add your first step below.
                </p>
            </div>

            <div *ngIf="!isAddingStep" class="add-step-section">
                <button
                    type="button"
                    mat-flat-button
                    mat-button
                    (click)="startAddingStep()"
                >
                    <mat-icon>add</mat-icon> Add
                    {{
                        (correctionSteps$ | async)?.length > 0 ? "another" : "a"
                    }}
                    step
                </button>
            </div>

            <app-batch-process-step-form
                *ngIf="isAddingStep"
                (newStepDefined)="addNewStep($event)"
                (cancel)="stopAddingStep()"
                [fieldTypeValues]="fieldTypeValues$ | async"
            >
            </app-batch-process-step-form>
            <div class="stepper-buttons" *ngIf="!isAddingStep">
                <button
                    type="button"
                    color="primary"
                    mat-flat-button
                    matStepperNext
                >
                    Preview Changes
                </button>
            </div>
        </mat-step>

        <mat-step label [editable]="false">
            <ng-template matStepLabel>Preview Result</ng-template>
            <app-batch-process-preview
                [errors]="errors$ | async"
                [preview]="preview$ | async"
            >
            </app-batch-process-preview>

            <app-reasoning-group [items]="reasoningItems"></app-reasoning-group>

            <div class="stepper-buttons">
                <button
                    type="button"
                    color="primary"
                    mat-flat-button
                    matStepperPrevious
                >
                    Previous
                </button>
                <button
                    type="button"
                    color="primary"
                    mat-flat-button
                    matStepperNext
                >
                    Perform Batch Correction
                </button>
            </div>
        </mat-step>

        <mat-step label>
            <ng-template matStepLabel>Complete</ng-template>
            <app-batch-process-completion> </app-batch-process-completion>
            <button
                type="button"
                color="primary"
                mat-flat-button
                matStepperNext
                (click)="navigateAway()"
            >
                Done
            </button>
        </mat-step>
    </mat-horizontal-stepper>
</div>
